import { NavLink } from 'react-router';

/** The blog section's own second row of tabs, shared by its pages. */
export default function BlogNav() {
  const tab = ({ isActive }: { isActive: boolean }) => (isActive ? 'tab is-active' : 'tab');

  return (
    <nav className="tabs tabs--sub" aria-label="Blog">
      <NavLink to="/blog" end className={tab}>
        Posts
      </NavLink>
      <NavLink to="/blog/topics" className={tab}>
        Topics
      </NavLink>
      <NavLink to="/blog/automation" className={tab}>
        Automation
      </NavLink>
      <NavLink to="/blog/tags" className={tab}>
        Tags
      </NavLink>
      <NavLink to="/blog/media" className={tab}>
        Media
      </NavLink>
    </nav>
  );
}
